import { FlowOutputStep } from '../types/FlowOutputStep';
import { IDataConnection } from '../types/IDataConnection';
import { IDataSource } from '../types/IDataSource';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export type GetFlowOutputStepsParams = {
  readonly flowId: string;
};

export type GetFlowOutputStepsResult = IResult & {
  readonly outputSteps: ReadonlyArray<FlowOutputStep>;
  readonly dataConnections: ReadonlyArray<IDataConnection>;
  readonly datasources: ReadonlyArray<IDataSource>;
};

export class GetFlowOutputStepsRequest extends Request<GetFlowOutputStepsParams, GetFlowOutputStepsResult> {
  constructor(params: GetFlowOutputStepsParams) {
    super('getFlowOutputSteps', params);
  }
}
